import React from 'react';
import { Modal } from 'antd';

export default class DefermentsInfoModal extends React.Component {
	render() {
		return (
			<Modal
				onCancel={this.props.onCancel}
				visible={this.props.visible}
				footer={null}>
				
				<legend>Direct Bill Students</legend>
				<p>
					Please note that your school has a direct bill arrangement with Semester at Sea. This means that you pay them and they will pay us.  Until they pay, your balance will remain deferred. Your Semester at Sea program fees will be paid to your school on their normal billing cycle rather than when Semester at Sea requires program fees to be paid for all other voyagers. You should meet with your school to understand their billing process and how to apply any home school aid to your bill. 
				</p>
				<p>
					It is possible that you will board the ship with a balance and be asked to sign a promissory note indicating that you are aware of your fiscal responsibility. This note is a formality that all students with deferred balances sign. If, however, your home institution has not paid their Direct Bill invoice within 30 days after embarkation, Semester at Sea reserves the right to turn this bill over to the student.
				</p>
				<br /><br />
				<legend>Home School Aid directly to SAS</legend>
				<p>
					Please note that a portion of your program fee balance has been deferred due to home school financial aid. Your home institution has indicated on your Financial Aid Notification form that your financial aid will be disbursed directly to Semester at Sea. This disbursement is expected to occur within 30 days after embarkation. If full payment is not received, you will be responsible for paying your remaining balance in full. 
				</p>
				<br /><br />
				<legend>Home School Aid directly to student</legend>
				<p>
					Please note that a portion of your program fee balance has been deferred due to homeschool aid. Your home institution has indicated on your Financial Aid Notification form that this aid will be released to you directly. It is then your responsibility to make full payment to Semester at Sea via the MyPassport portal. Full payment is expected to occur by the date listed on the Financial Aid Notification form. If full payment is not received, you will be responsible for paying your remaining balance in full.
				</p>

			</Modal>
		);
	}
}


// WEBPACK FOOTER //
// ./portal-components/Portal/Financial/FinancialAid/DefermentsInfoModal.jsx